import React from 'react';
import IntersectionObserverWrapper from '../IntersectionObserverWrapper/IntersectionObserverWrapper';
import CustomColumnManagerItem from './CustomColumnManagerItem';
import { Button } from '../UI/Button/Button';

const CustomColumnManagerMobileVersion = ({
  filteredColumns,
  handleColumnCheckbox,
  isMobileVersion,
  toggleColumnVisibility,
  numberOfVisibleColumns,
  isAllColumnsVisible,
}) => {
  return (
    <div className='relative flex flex-col  h-full'>
      <div className='grow flex flex-col overflow-auto'>
        <hr className='mb-3' />
        <div className='flex-1 '>
          {!filteredColumns.length ? (
            <div className='flex items-start justify-center h-full text-shadow-600'>No options</div>
          ) : (
            filteredColumns.map((col, index) => {
              return (
                <div
                  key={col.field}
                  className='py-1 h-8'
                  draggable
                  onDragStart={() => {}}
                  onDragOver={() => {}}
                  onDrop={() => {}}
                >
                  <IntersectionObserverWrapper>
                    <CustomColumnManagerItem
                      col={col}
                      handleColumnCheckbox={handleColumnCheckbox}
                      handleColumnSelection={() => {}}
                      handleDeleteColumn={() => {}}
                      selectedColumn={[]}
                      colIndex={index}
                      handleRightMouseClick={() => {}}
                      isMobileVersion={isMobileVersion}
                    />
                  </IntersectionObserverWrapper>
                </div>
              );
            })
          )}
        </div>
        <hr className='mt-3' />
      </div>
      <div className=' flex justify-around items-center py-2 bg-white'>
        <Button
          color='shadow'
          size='large'
          onClick={() => toggleColumnVisibility(true)}
          disabled={!numberOfVisibleColumns}
          className='!w-40'
        >
          Hide All
        </Button>
        <Button
          color='shadow'
          size='large'
          onClick={() => toggleColumnVisibility(false)}
          disabled={isAllColumnsVisible}
          className='!w-40'
        >
          Show All
        </Button>
      </div>
    </div>
  );
};

export default CustomColumnManagerMobileVersion;
